import * as React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditNoteModal from './EditNotes';
import ConfirmPopups from './ConfirmPopup';
import JobScheduleVoidModalData from './JobScheduleVoidModal';
import JobInfoData from './ScheduleNewJobInfoModal';
import RescheduleJobData from './ScheduleNewRescheduleModal';
import AllocateMultiTrucksSimpleModal from './AllocateMultiTrucksSimple';
import JobQuoteDeliveryAddressData from './JobQuoteDeliveryAddressModal';
import type { DeliveryAddress, TruckListOption } from './models/JobInterfaces';
import type { GenericList } from './models/JobSharedInterfaces';
import { GetQuery, PostQuery } from './Shared';

type EventJobProps = {
    scheduleDate: string;
    scheduleDateFormatted: string;
    scheduleDateFormattedSmall: string;
    systemCompanyId: number;
    eventDayTotals: EventDayTotals;
    canEdit: boolean;
    scheduleTypes: GenericList[];
    trucks: TruckListOption[];
    jobs: EventJob[];
    saveDayOrder(scheduleDate: string, jobs: EventJob[]): void;       //saves the day order and updates the list of jobs
    saveJob(scheduleDate: string, jobIndex: number, updatedJob: EventJob): void;                //saves updated job and only updates that job within the list of jobs
    updateDay(scheduleDate: string): void;
}

type EventDayTotals = {
    eventToiletTotal: number;
    disabledToiletTotal: number;
    hydrationStationTotal: number;
    dayAmountFormatted: string;
}

type EventJob = {
    id: number;
    jobId: number;
    jobQuoteItemId: number;
    companyId: number;
    scheduledDate: string;
    scheduledBranch: string;
    scheduledBranchId: number;
    truckId: number;
    truck: string;
    eventName: string;
    customerId: number;
    customer: string;
    siteAddress: string;
    deliveryAddress: string;
    deliveryAddressGooglePlaceId: string;
    deliveryAddressLatitude: number;
    deliveryAddressLongitude: number;
    invoiceDescription: string;
    description: string;
    manualItem: boolean;
    type: string;
    typeId: number;
    itemId: number;
    item: string;
    itemShortcut: string;
    itemTypeId: number;
    quantityScheduled: number;
    quantityType: string;
    offhireDate: string;
    accountChecked: boolean;
    goAhead: boolean;
    callout: boolean;
    showRedNotes: boolean;
    showGreenNotes: boolean;
    scheduleNotes: string;
    status: string;
    statusId: number;
    customerUpdatesRequired: boolean;
    craneTruckRequired: boolean;
    jobOrder: number;
    isPlaceholder: boolean;
    purchaseOrderNumber: string;
    trolley: boolean;
    rowVersionTimestamp: Uint8Array;
    canEdit: boolean;
    canDelete: boolean;
}

const ScheduleEventJobsData = (props: EventJobProps) => {
    const [showJobInfo, setShowJobInfo] = React.useState(false);
    const [showVoidGearList, setShowVoidGearList] = React.useState(false);
    const [scheduleId, setScheduleId] = React.useState(-1);
    const [scheduleIndex, setScheduleIndex] = React.useState(-1);
    const [showNotes, setShowNotes] = React.useState(false);
    const [showCancel, setShowCancel] = React.useState(false);
    const [showReschedule, setShowReschedule] = React.useState(false);
    const [showMultipleTrucksSimple, setShowMultipleTrucksSimple] = React.useState(false);
    const [jobQuoteItemId, setJobQuoteItemId] = React.useState(-1);
    const [deliveryAddress, setDeliveryAddress] = React.useState<DeliveryAddress>({
        deliveryAddress: "",
        deliveryAddressGooglePlaceId: "",
        deliveryAddressLatitude: 0,
        deliveryAddressLongitude: 0
    });
    const [invoiceDescription, setInvoiceDescription] = React.useState("");
    const [showDelAddress, setShowDelAddress] = React.useState(false);
    const [dragStartIndex, setDragStartIndex] = React.useState(-1);
    const [dragEndIndex, setDragEndIndex] = React.useState(-1);

    //REFRESH DAY
    const refreshDay = () => {
        props.updateDay(props.scheduleDate);
    }
    //END REFRESH DAY

    const onTruckCellChange = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        job.truckId = e.target.value;
        saveJob(job);
    }

    const onGoAheadCheckboxChange = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        job.goAhead = e.target.checked;
        saveJob(job);
    }

    const saveJob = async (job: EventJob) => {
        var saveEventJob = {
            id: job.id, 
            truckId: job.truckId,
            goAhead: job.goAhead,
            rowVersionTimestamp: job.rowVersionTimestamp
        };

        var jsonItem = JSON.stringify(saveEventJob);

        const apiUrl = "SaveEventJob";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Job Saved");

                //update current day
                props.updateDay(props.scheduleDate);
            }
        }
    }

    //JOB INFO
    const showInfo = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        setScheduleIndex(jobIndex);
        setShowJobInfo(true);
        setScheduleId(job.id);
    }

    const hideJobInfo = () => {
        setShowJobInfo(false);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
        setScheduleIndex(-1);
    }

    const openGearlist = () => {
        var job = props.jobs[scheduleIndex];
        setJobQuoteItemId(job.jobQuoteItemId);
        setShowJobInfo(false);
        setShowVoidGearList(false);
    }

    const saveJobInfo = () => {
        setShowJobInfo(false);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
        setScheduleIndex(-1);
        refreshDay();
    }
    //END JOB INFO

    //VOID GEAR LIST
    const hideVoidGearList = () => {
        setShowVoidGearList(false);
        setShowJobInfo(true);
        setJobQuoteItemId(-1);
    }

    const saveVoidGearList = () => {
        setShowVoidGearList(false);
        setShowJobInfo(true);
        setJobQuoteItemId(-1);
    }
    //END VOID GEARLIST

    //RESCHEDULE JOB
    const rescheduleJob = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];

        setShowReschedule(true);
        setScheduleId(job.id);
    }

    const hideReschedule = () => {
        setShowReschedule(false);
        setScheduleId(-1);
    }

    const saveRescheduleItem = (scheduleDateNew: string) => {
        props.updateDay(props.scheduleDate);
        props.updateDay(scheduleDateNew);
        setShowReschedule(false);
        setScheduleId(-1);
    }
    //END RESCHEDULE JOB

    //ALLOCATE MULTIPLE TRUCKS
    //simple
    const allocateMultiTrucksSimple = (e: any, itemIndex: number) => {
        e.preventDefault();

        var job = props.jobs[itemIndex];
        setShowMultipleTrucksSimple(true);
        setScheduleId(job.id);
        setJobQuoteItemId(job.jobQuoteItemId);
    }

    const hideMultipleTrucksSimple = () => {
        setShowMultipleTrucksSimple(false);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
    }

    const saveMultipleTrucksSimple = () => {
        setShowMultipleTrucksSimple(false);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
        props.updateDay(props.scheduleDate);
    }
    //end simple
    //END ALLOCATE MULTIPLE TRUCKS

    //CANCEL JOB
    const cancelJob = (e: any, jobIndex: number) => {
        e.preventDefault();
        setScheduleIndex(jobIndex);
        setShowCancel(true);
    }

    const hideCancel = () => {
        setScheduleIndex(-1);
        setShowCancel(false);
    }

    const saveCancel = () => {
        saveCancelItem();
    }

    const saveCancelItem = async () => {
        //get id from item we want to delete
        var job = props.jobs[scheduleIndex];

        const apiUrl = 'DeleteItem?ScheduleId=' + job.id;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setScheduleId(-1);
            setShowCancel(false);
            props.updateDay(props.scheduleDate);

            toast.success("Item has been unscheduled");
        } 
    }
    //END CANCEL JOB

    //NOTES
    const showEditNotes = (e: any, itemIndex: number) => {
        e.preventDefault();

        var eventJobs = props.jobs;
        var eventJob = eventJobs[itemIndex];
        var scheduleId = eventJob.id;

        setScheduleId(scheduleId);
        setScheduleIndex(itemIndex);
        setShowNotes(true);
    }

    const hideNotes = () => {
        setScheduleId(-1);
        setScheduleIndex(-1);
        setShowNotes(false);
    }

    const saveNotes = (scheduleNotes: string, timestamp: Uint8Array) => {
        var eventJobs = props.jobs;
        var eventJob = eventJobs[scheduleIndex];

        eventJob.scheduleNotes = scheduleNotes;
        eventJob.rowVersionTimestamp = timestamp;
        eventJob.showGreenNotes = scheduleNotes.length > 0;
       
        setScheduleId(-1);
        setShowNotes(false);
        props.saveJob(props.scheduleDate, scheduleIndex, eventJob);
        setScheduleIndex(-1);
    }
    //END NOTES

    //DELIVERY ADDRESS
    const editDelAddress = (e: any, itemIndex: number) => {
        e.preventDefault();

        var eventJobs = props.jobs;
        var eventJob = eventJobs[itemIndex];

        setScheduleIndex(itemIndex);
        setScheduleId(eventJob.id);
        var delAddr:DeliveryAddress = {
            deliveryAddress: eventJob.deliveryAddress,
            deliveryAddressGooglePlaceId: eventJob.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: eventJob.deliveryAddressLatitude,
            deliveryAddressLongitude: eventJob.deliveryAddressLongitude
        };
        setDeliveryAddress(delAddr);
        setInvoiceDescription(eventJob.invoiceDescription);
        setShowDelAddress(true);
    }

    const hideDelAddress = () => {
        setShowDelAddress(false);
        var delAddr = resetDeliveryAddress();
        setDeliveryAddress(delAddr);
        setInvoiceDescription("");
        setScheduleIndex(-1);
        setScheduleId(0);
    }

    const updateDelAddress = (updatedDeliveryAddress: DeliveryAddress) => {
        setDeliveryAddress(updatedDeliveryAddress);
    }

    const clearDelAddress = () => {
        var delAddress = resetDeliveryAddress();
        setDeliveryAddress(delAddress);
    }

    const resetDeliveryAddress = () => {
        var delAddr: DeliveryAddress = {
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0
        };
        return delAddr;
    }

    const updateInvDesc = (updatedInvoiceDescription: string) => {
        setInvoiceDescription(updatedInvoiceDescription);
    }

    const updateTrolley = (_updatedTrolley: boolean) => {
        //not used
    }

    const saveDelAddress = () => {
        saveDeliveryAddress();
    }

    const saveDeliveryAddress = async () => {
        var eventJobs = props.jobs;
        var eventJob = eventJobs[scheduleIndex];

        eventJob.deliveryAddress = deliveryAddress.deliveryAddress;
        if (deliveryAddress.deliveryAddress != "") {
            eventJob.siteAddress = deliveryAddress.deliveryAddress;
        }
        eventJob.invoiceDescription = invoiceDescription;

        var saveDelAddress = {
            scheduleId: eventJob.id,
            jobQuoteItemId: eventJob.jobQuoteItemId,
            deliveryAddress: deliveryAddress.deliveryAddress,
            googlePlaceId: deliveryAddress.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: deliveryAddress.deliveryAddressLatitude,
            deliveryAddressLongitude: deliveryAddress.deliveryAddressLongitude,
            invoiceDescription: invoiceDescription,
            trolley: eventJob.trolley
        };

        var jsonItem = JSON.stringify(saveDelAddress);

        const apiUrl = "SaveDeliveryAddress";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            toast.success("Extras Saved");
            var delAddress = resetDeliveryAddress();

            setScheduleIndex(-1);
            setScheduleId(0);
            var delAddress = resetDeliveryAddress();
            setDeliveryAddress(delAddress);
            setInvoiceDescription("");
            setShowDelAddress(false);

            eventJob.rowVersionTimestamp = result.data;
            props.saveJob(props.scheduleDate, scheduleIndex, eventJob);
        }
    }
    //END DELIVERY ADDRESS

    const onDragStart = (index: number) => {
        setDragStartIndex(index);
    }

    const onDragEnter = (index: number) => {
        setDragEndIndex(index);
    }

    const onDragEnd = (e: any) => {
        e.preventDefault();

        if (dragStartIndex != dragEndIndex) {
            var jobs = [...props.jobs];
            jobs.splice(dragEndIndex, 0, jobs.splice(dragStartIndex, 1)[0]);

            var jobOrder = 1;
            //loop through the items and update the order
            for (var j = 0; j < jobs.length; j++) {
                let job = jobs[j];

                job.jobOrder = jobOrder;
                jobOrder += 1;
            }
            props.saveDayOrder(props.scheduleDate, jobs);
        }

        setDragStartIndex(-1);
        setDragEndIndex(-1);
    }

    const jobInfo = <JobInfoData systemCompanyId={props.systemCompanyId} scheduleId={scheduleId} showModal={showJobInfo} hideModal={hideJobInfo} openGearlist={openGearlist} saveModal={saveJobInfo} />
    const editVoidGearlist = <JobScheduleVoidModalData showModal={showVoidGearList} jobQuoteItemId={jobQuoteItemId} hideModal={hideVoidGearList} saveModal={saveVoidGearList} />
    const notes = <EditNoteModal systemCompanyId={props.systemCompanyId} scheduleId={scheduleId} editDriverNotes={false} showDriverScheduleNotes={false} showEditNotesModal={showNotes} save={saveNotes} hideModal={hideNotes} />
    const confirmCancel = <ConfirmPopups heading="Cancel Job" text="Are you sure you want to cancel this job?" showConfirmModal={showCancel} hideConfirmModal={hideCancel} saveConfirmModal={saveCancel} />
    const rescheduleJobItem = <RescheduleJobData publicHolidays={[]} shutdownPeriods={[]} reasonOptions={[]} showModal={showReschedule} hideModal={hideReschedule} scheduleId={scheduleId} saveModal={saveRescheduleItem} />
    const multiTrucksSimple = <AllocateMultiTrucksSimpleModal showModal={showMultipleTrucksSimple} truckOptions={props.trucks} scheduleId={scheduleId} jobQuoteItemId={jobQuoteItemId} scheduleDate={props.scheduleDate} hideModal={hideMultipleTrucksSimple} save={saveMultipleTrucksSimple} />
    const delAddressPopup = <JobQuoteDeliveryAddressData deliveryAddress={deliveryAddress} showDeliveryAddress={true} invoiceDescription={invoiceDescription} showInvoiceDescription={true} trolleyRequired={false} showTrolley={false} readOnly={false} showModal={showDelAddress} hideModal={hideDelAddress} updateDeliveryAddress={updateDelAddress} clearDeliveryAddress={clearDelAddress} updateInvoiceDescription={updateInvDesc} updateTrolley={updateTrolley} saveModal={saveDelAddress} />

    return (
        <div>
            <div>
                {jobInfo}
                {editVoidGearlist}
                {notes}
                {confirmCancel}
                {rescheduleJobItem}
                {multiTrucksSimple}
                {delAddressPopup}
            </div>
            <div>
                <div className="schedulenew__statusBar">
                    <span className="schedulenew__day marginRight10">{props.scheduleDateFormatted}</span>
                    <div>
                        <button className="defaultbutton defaultbutton__small--height marginLeft10" type='button' title="Refreshes the current day" onClick={refreshDay}>Refresh</button>
                        {/*<button className={props.systemCompanyId === 2 && props.canEdit ? "defaultbutton defaultbutton__small--height marginLeft10" : "hidden"} type='button' title="Allows user to add an existing quoted job, dismantle or manual job to the current day" onClick={add}>Add New</button>*/}
                    </div>
                </div>
                <div className="schedulenew__statusBar">
                    <div>
                        <span>Event Toilets: {props.eventDayTotals.eventToiletTotal}</span>
                        <span className="marginLeft10">Disabled Toilets: {props.eventDayTotals.disabledToiletTotal}</span>
                        <span className="marginLeft10">Hydration Stations: {props.eventDayTotals.hydrationStationTotal}</span>
                    </div>
                    <div><span>Day Total: {props.eventDayTotals.dayAmountFormatted}</span></div>
                </div>
                <div className="overflowAuto tableColours-header marginTop10">
                    <table className="table table__extralarge">
                        <thead>
                            <tr>
                                <th className="hidden"></th>
                                <th className="table--col-xs"></th>
                                <th className="table--col-xs"></th>
                                <th>Event</th>
                                <th>Site Address</th>
                                <th className="table--col-xs"></th>
                                <th>Customer</th>
                                <th className="table--col-s">Item</th>
                                <th className="table--col-s">Qty</th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Paid
                                        <span className="tooltipitemtext tooltipitemtext__right">Account is ok / Prepaid account paid</span>
                                    </div>
                                </th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Go Ahead
                                        <span className="tooltipitemtext tooltipitemtext__right">Item is ready to go and runsheet can be printed.</span>
                                    </div>
                                </th>
                                <th className="table--col-m">Truck</th>
                                <th className="table--col-xs"></th>
                                <th className="table--col-xs">
                                    <div className="tooltipitem tooltipitem__left">Multi
                                        <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">Split the job over multiple trucks</span>
                                    </div>
                                </th>
                                <th className="table--col-xs">
                                    <div className="tooltipitem tooltipitem__left">Sch
                                        <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">Re-schedule the job to another day</span>
                                    </div>
                                </th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__left">Notes
                                        <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">View/Add Notes to the job</span>
                                    </div>
                                </th>
                                <th className="table--col-xs"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.jobs.map((job, index) =>
                                <tr key={index} className={(job.itemTypeId === 26 || job.itemTypeId === 36) ? "tableColours--pc--oneoff" : job.manualItem ? "tableColours--manual" : job.typeId === 3 ? "tableColours--assist" : job.typeId === 4 ? "tableColours--cleaning" : job.typeId === 5 ? "tableColours--manual" : job.typeId === 1 && job.isPlaceholder ? "tableColours--install-ph" : job.typeId === 1 ? "tableColours--install" : job.typeId === 2 && job.isPlaceholder ? "tableColours--pickup-ph" : job.typeId === 2 ? "tableColours--pickup" : ""} onDragStart={() => onDragStart(index)} onDragEnter={() => onDragEnter(index)} onDragEnd={(e) => onDragEnd(e)} draggable>
                                    <td className="hidden">{job.id}</td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText" : "table__text--align"}>
                                        {index + 1}
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText table--col-xs" : "table__text--align table--col-xs"}>
                                        <div className="">
                                            <a className="tooltipitem tooltipitem__right" href="#" onClick={(e) => showInfo(e, index)}>
                                                <span className="fas fa-info-circle copy--icon alignIconCenter"></span><span className="tooltipitemtext tooltipitemtext__right">Booking Information</span>
                                            </a>
                                        </div>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText" : "table__text--align"}>
                                        {job.eventName}
                                    </td>
                                    <td className={"table__text--align"}>
                                        <Link className={job.jobId > 0 && job.companyId == props.systemCompanyId ? (job.customerUpdatesRequired ? "allocate__customerText" : "") : "hidden"} to={'/job/' + job.jobId + '/details'} target="_blank">
                                            <div className="tooltipitem tooltipitem__right">{job.siteAddress && job.siteAddress.length > 30 ? job.siteAddress.substring(0, 30) + "... " : job.siteAddress ? job.siteAddress : ""}
                                                <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                                            </div>
                                        </Link>
                                        <div className={job.jobId == 0 || job.companyId != props.systemCompanyId ? "tooltipitem tooltipitem__right" : "hidden"}>{job.siteAddress && job.siteAddress.length > 30 ? job.siteAddress.substring(0, 30) + "... " : job.siteAddress ? job.siteAddress : ""}
                                            <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                                        </div>
                                    </td>
                                    <td className="table__text--align">
                                        <a href="#" className={job.manualItem ? "hidden" : ""} onClick={(e) => editDelAddress(e, index)}>
                                            <span className={"fas fa-edit edit--icon alignIconCenter tooltipitem tooltipitem__right" + (job.deliveryAddress === "" ? "" : " makeitgreen")}><span className="tooltipitemtext tooltipitemtext__right">Add a different delivery address</span></span>
                                        </a>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText" : "table__text--align"}>
                                        <div className="tooltipitem tooltipitem__right">{job.customer.length > 25 ? job.customer.substring(0, 25) + "... " : job.customer}
                                            <span className="tooltipitemtext tooltipitemtext__right">{job.customer}</span>
                                        </div>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText table--col-s" : "table__text--align table--col-s"}>
                                        <div className="tooltipitem tooltipitem__right">{job.manualItem ? job.description.substring(0, 5) + "... " : job.itemShortcut}
                                            <span className="tooltipitemtext tooltipitemtext__right">{job.manualItem ? job.description : job.invoiceDescription != "" ? job.invoiceDescription : job.item}</span>
                                        </div>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align table--cell--nowrap allocate__customerText table--col-s" : "table__text--align table--cell--nowrap table--col-s"}>
                                        <span className="tooltipitemtext tooltipitemtext__right">{job.quantityType}</span>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText table--col-s" : "table__text--align table--col-s"}>
                                        <div>
                                            <input name="accountChecked" type='checkbox' className="input" checked={job.accountChecked} readOnly disabled />
                                        </div>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText table--col-s" : "table__text--align table--col-s"}>
                                        <div>
                                            <input name="goAhead" type='checkbox' className="input" checked={job.goAhead} onChange={(e) => onGoAheadCheckboxChange(e, index)} disabled={job.statusId < 2 || job.statusId > 3 || !props.canEdit || !job.accountChecked || !job.canEdit} />
                                        </div>
                                    </td>
                                    <td className={job.customerUpdatesRequired ? "table__text--align allocate__customerText table--col-s" : "table__text--align table--col-s"}>
                                        <select className={props.canEdit && job.canEdit && job.companyId == props.systemCompanyId ? "select" : "hidden"} id="truckId" name="truckId" value={job.truckId} onChange={(e) => onTruckCellChange(e, index)}>
                                            <option defaultValue="-1" value={-1}></option>
                                            {props.trucks.map(truck =>
                                                <option key={truck.id} value={truck.id}>{truck.name}</option>
                                            )};
                                        </select>
                                        {props.canEdit && job.canEdit && job.companyId == props.systemCompanyId ? "" : job.truck}
                                    </td>
                                    <td className="table__text--align table--col-s">
                                        <span className={job.craneTruckRequired ? "alignIconCenter tooltipitem tooltipitem__left" : "hidden"}>
                                            <span className="fa-solid fa-circle-exclamation copy--icon makeitred"></span>
                                            <span className="tooltipitemtext  tooltipitemtext__large tooltipitemtext__left">Crane Truck Required</span>
                                        </span>
                                    </td>
                                    <td className="table__text--align table--col-xs">
                                        <div className={props.canEdit && job.canEdit && job.quantityScheduled > 1 && job.truckId > 0 && job.companyId == props.systemCompanyId ? "" : "hidden"}>
                                            <a href="#" onClick={(e) => allocateMultiTrucksSimple(e, index)}>
                                                <span className="fas fa-link copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Allocate job to multiple trucks</span></span>
                                            </a>
                                        </div>
                                    </td>
                                    <td className="table__text--align table--col-xs">
                                        <div className={props.canEdit && job.canEdit && job.companyId == props.systemCompanyId ? "" : "hidden"}>
                                            <a href="#" onClick={(e) => rescheduleJob(e, index)}>
                                                <span className="fas fa-calendar-alt copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Reschedule job to another day</span></span>
                                            </a>
                                        </div>
                                    </td>
                                    <td className="table__text--align allocate-notes--width">
                                        <a className={job.scheduleNotes == "" ? "hidden" : job.showRedNotes ? " makeitred" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => showEditNotes(e, index)}>
                                            <div className="tooltipitem tooltipitem__left">{job.scheduleNotes ? job.scheduleNotes.length < 60 ? job.scheduleNotes : job.scheduleNotes.substring(0, 60) + "... " : ""}
                                                <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">{job.scheduleNotes}</span>
                                            </div>
                                        </a>
                                        <a className={job.scheduleNotes != "" ? "hidden" : job.showRedNotes ? " makeitred" : job.showGreenNotes ? " makeitgreen" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => showEditNotes(e, index)}>
                                            <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                        </a>
                                    </td>
                                    <td className="table__text--align table--col-xs">
                                        {props.canEdit && job.canDelete && job.companyId == props.systemCompanyId ?
                                            <div className="delete--tablecell tooltipitem tooltipitem__left">
                                                <a href="#" onClick={(e) => cancelJob(e, index)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter makeitred tooltipitem tooltipitem__left"></span><span className="tooltipitemtext tooltipitemtext__left">Cancel Booking</span>
                                                </a>
                                            </div> : ""
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ScheduleEventJobsData;
